<template>
	<div
		class="fixed bottom-0 left-0 right-0 top-0 flex flex-col bg-fill-primary dark:bg-fill-secondary"
	>
		<AlertGroup class="fixed left-4 right-4 top-4" />
		<div class="overflow-scroll p-2" id="view">
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
import AlertGroup from '../components/AlertGroup.vue'
</script>
